import React from "react";
import { useBranding } from "@/contexts/BrandingContext";
import { LoginLeftPanel } from "@/components/login/LoginLeftPanel";
import { LoginForm } from "@/components/login/LoginForm";
import { dk } from "@/components/login/loginDark";

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300;1,9..144,300&family=Instrument+Sans:wght@400;500&display=swap');

  @keyframes riseIn {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes drift {
    0%, 100% { transform: translate(0, 0) scale(1); }
    50%       { transform: translate(-12px, 14px) scale(1.04); }
  }
  @keyframes drift-slow {
    0%, 100% { transform: translate(0, 0); }
    50%       { transform: translate(10px, -10px); }
  }
  @keyframes logoSpin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }

  .fraunces { font-family: 'Fraunces', ui-serif, Georgia, serif; }
  .rise { animation: riseIn 800ms cubic-bezier(.22,.68,0,1.2) both; }
  .rise-1 { animation-delay: 60ms; }
  .rise-2 { animation-delay: 140ms; }
  .rise-3 { animation-delay: 220ms; }
  .rise-4 { animation-delay: 300ms; }
  .rise-5 { animation-delay: 380ms; }
  .drift      { animation: drift 14s ease-in-out infinite; }
  .drift-slow { animation: drift-slow 18s ease-in-out infinite; }

  .dark-input {
    width: 100%;
    background: ${dk.surface};
    border: 1px solid ${dk.hairline};
    border-radius: 10px;
    color: ${dk.ink};
    caret-color: ${dk.sageBright};
    padding: 13px 16px;
    font-size: 14px;
    outline: none;
    transition: border-color .2s ease, box-shadow .2s ease;
  }
  .dark-input::placeholder { color: ${dk.muted}; opacity: 0.7; }
  .dark-input:focus {
    border-color: ${dk.sageMid};
    box-shadow: 0 0 0 3px ${dk.glow}, 0 0 16px ${dk.glow};
  }
  .dark-input:disabled { opacity: 0.45; cursor: not-allowed; }

  .input-wrap:focus-within .input-icon { color: ${dk.sageBright} !important; }

  .submit-btn {
    background: linear-gradient(135deg, ${dk.sage} 0%, ${dk.sageMid} 100%);
    border: 1px solid ${dk.sageMid};
    cursor: pointer;
    transition: box-shadow .25s ease, transform .2s ease, background .2s ease;
  }
  .submit-btn:hover:not(:disabled) {
    box-shadow: 0 4px 28px ${dk.glowStrong};
    transform: translateY(-1px);
    background: linear-gradient(135deg, ${dk.sageMid} 0%, ${dk.sageBright} 100%);
  }
  .submit-btn:active:not(:disabled) { transform: translateY(0); }
  .submit-btn:disabled { opacity: 0.45; cursor: not-allowed; }
`;

export const Login: React.FC = () => {
  const { branding } = useBranding();
  const appName = branding?.appName ?? "Ammayum Kunjum";

  return (
    <div
      className="min-h-screen w-full font-[Instrument_Sans,ui-sans-serif,system-ui]"
      style={{ background: dk.bg, color: dk.ink }}
    >
      <style>{css}</style>
      <div className="grid min-h-screen lg:grid-cols-[1.15fr_1fr]">
        <LoginLeftPanel appName={appName} />
        <LoginForm appName={appName} />
      </div>
    </div>
  );
};
